import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AgCellRendererComponent } from '../../../../global/gx-ag-grid/ag-cell-renderer.component';
import { CcCompletionCellLocalStoreService } from './cc-completion-cell-local-store.service';
import { LocationListLocalStoreService } from '../../location-list-local-store.service';
import { Store } from '@ngrx/store';
import { CCCompletionActions } from '../../state/location-list-actions';
import { Location } from '../../../../../models/locations-models/location';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { NgClass } from '@angular/common';
import { MatTooltip } from '@angular/material/tooltip';
import { MatIcon } from '@angular/material/icon';
import { GtagEventDirective } from '../../../../../core/gx-gtag/gtag-event.directive';
import { MatIconButton } from '@angular/material/button';
import { LetDirective } from '@ngrx/component';

@Component({
    selector: 'app-cc-completion-cell',
    templateUrl: './cc-completion-cell.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [CcCompletionCellLocalStoreService],
    standalone: true,
    imports: [LetDirective, MatIconButton, GtagEventDirective, MatIcon, MatTooltip, NgClass, MatProgressSpinner]
})
export class CcCompletionCellComponent extends AgCellRendererComponent {

  viewModel$ = this.localStore.viewModel$;

  constructor(protected localStore: CcCompletionCellLocalStoreService,
              private locationListLocalStore: LocationListLocalStoreService,
              private store: Store) {
    super(localStore);
  }

  /**
   * Changes the claimAndCleanCompletionTimestamp value of the location on the BE. If the location
   * is currently not marked as completed, the timestamp will be the current time. If it is already
   * marked as completed, the new timestamp will be null (un-marking as completed).
   * @param location Location to be (un)marked as cc-completed
   */
  toggleClaimCleanCompletion(location: Location) {
    const shouldBeMarkedAsCompleted: boolean = !location.claimAndCleanCompletionTimestamp;

    this.locationListLocalStore.addCcCompletionSpinner(location.id);
    this.store.dispatch(CCCompletionActions.updateCcCompletionTimestamp({
      location: location,
      completed: shouldBeMarkedAsCompleted,
    }));
  }
}
